import { render, staticRenderFns } from "./runWorkoutExerciseList.vue?vue&type=template&id=22497468&scoped=true"
import script from "./runWorkoutExerciseList.vue?vue&type=script&lang=js"
export * from "./runWorkoutExerciseList.vue?vue&type=script&lang=js"
import style0 from "./runWorkoutExerciseList.vue?vue&type=style&index=0&id=22497468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22497468",
  null
  
)

export default component.exports